import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { toNumber } from 'lodash';
import { withRouter, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import ImageSliderStandard from 'components/consumer/image-slider-standard';
// import getBreakpoint from 'commons/getBreakpoint';
import ProductPageSectionTitle from 'components/consumer/ProductPageSectionTitle/ProductPageSectionTitle';
import CtaLink from 'components/essentials/Cta/CtaLink';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import ReviewCard from './ReviewCard';
import testimonials from './testimonials';
import { GET_PRODUCT_REVIEWS } from './queries';
const DEFAULT_REVIEWS = [];
const SlickButtonFix = t0 => {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    const {
      currentSlide,
      slideCount,
      children: t1,
      ...t2
    } = t0;
    children = t1;
    props = t2;
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = <span {...props}>{children}</span>;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
SlickButtonFix.propTypes = {
  children: PropTypes.node,
  currentSlide: PropTypes.shape({
    src: PropTypes.string,
    url: PropTypes.string,
    value: PropTypes.string
  }),
  slideCount: PropTypes.number
};
const Testimonial = item => {
  const $ = _c(7);
  let t0;
  if ($[0] !== item.image) {
    t0 = <div className="h-10 flex items-center justify-start mx-auto my-0 lg:justify-center"><img src={item.image} alt="" /></div>;
    $[0] = item.image;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== item.text) {
    t1 = <p>{item.text}</p>;
    $[2] = item.text;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className="text-base text-gray mr-10 max-w-[70%] min-w-[240px] [&_p]:font-normal">{t0}{t1}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const CustomerReviews = t0 => {
  const $ = _c(17);
  const {
    fromModularLink: t1,
    staticContext,
    product,
    match,
    productName,
    id
  } = t0;
  const fromModularLink = t1 === undefined ? "" : t1;
  const {
    slug
  } = useParams();
  let t2;
  if ($[0] !== id || $[1] !== slug) {
    t2 = {
      variables: {
        id,
        slug,
        sortBy: "date-desc",
        offset: 0,
        limit: 12
      },
      fetchPolicy: "cache-and-network"
    };
    $[0] = id;
    $[1] = slug;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data
  } = useSuspenseQuery(GET_PRODUCT_REVIEWS, t2);
  const reviews = data?.productReviews?.reviews ?? DEFAULT_REVIEWS;
  if (!data) {
    return null;
  }
  const {
    productReviews
  } = data;
  const averageScore = productReviews.averageRating ?? 0;
  let t3;
  if ($[3] !== reviews || $[4] !== staticContext) {
    t3 = reviews?.length ? reviews.map(item => <ReviewCard productReview={item} key={item.id} staticContext={staticContext} />) : null;
    $[3] = reviews;
    $[4] = staticContext;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const reviewsList = t3;
  const finalCTALink = product ? fromModularLink || `/${match.params.category}/${product?.slug}/` : "";
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="text-lg font-bold flex items-center justify-center">Loading..</div>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== averageScore || $[8] !== finalCTALink || $[9] !== product || $[10] !== productName || $[11] !== productReviews.totalReviews || $[12] !== reviews?.length || $[13] !== reviewsList) {
    t5 = reviews?.length > 0 && <div data-xc="customer-product-reviews" className="reviews"><div className="p-0 mb-0"><MobileAndTabletOnly><div className="lg:hidden text-base pb-2 font-bold text-gray"><span>{toNumber(averageScore).toFixed(1)} / 5 ({productReviews.totalReviews || 0} Reviews)</span></div></MobileAndTabletOnly><ProductPageSectionTitle className="text-2xl flex items-center font-bold [&_span]:text-base [&_span]:text-gray [&_span]:mt-[.4rem] [&_span]:ml-4">Customers love the {product ? product.name : productName || ""}<DesktopOnly><span className="max-[1023px]:hidden">{toNumber(averageScore).toFixed(1)} / 5 ({productReviews.totalReviews || 0} Reviews)</span></DesktopOnly></ProductPageSectionTitle>{product?.name && <p className="text-base mt-0 mx-0 mb-4 hidden lg:block">Read real customer reviews and what they’re saying about this product.</p>}</div><div className="pb-8 lg:pt-[.8rem] lg:px-0 lg:pb-8"><div className="max-w-full flex-[1_1] block min-h-0 min-w-0 mt-4 mx-0 mb-8 lg:mt-0 lg:mx-0 lg:mb-4 lg:p-0">{reviewsList && <ImageSliderStandard config={{
            children: reviewsList,
            sliderConfig: {
              navType: "Button",
              visibleSlides: 3,
              imageHeight: 430
            },
            variation: {
              value: "Component"
            }
          }} fullWidth={true} variant="reviews-list" />}</div>{product?.slug && <CtaLink to={`${finalCTALink}reviews`} styling="outline-button" color="brand">See all{" "}{productReviews.totalReviews ? productReviews.totalReviews : 0}{" "}Reviews</CtaLink>}</div><div className="flex [border-top:2px_solid_#f8f8f8] overflow-auto pt-8 flex-nowrap pb-0 lg:mt-4 lg:pt-16 lg:pb-0 [&_div]:text-sm [&_div]:flex-[1_1] [&_div]:text-gray [&_div]:mr-8 [&_div]:w-[280px] [&_div:last-child]:last:mr-0 [&_div]:lg:text-center [&_div]:lg:w-auto [&_div]:lg:mr-16 [&_div_p]:font-normal [&_div_p]:mb-0 [&_img]:mb-4">{testimonials.map(_temp)}</div></div>;
    $[7] = averageScore;
    $[8] = finalCTALink;
    $[9] = product;
    $[10] = productName;
    $[11] = productReviews.totalReviews;
    $[12] = reviews?.length;
    $[13] = reviewsList;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <SuspenseWithLoader fallback={t4}>{t5}</SuspenseWithLoader>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default withRouter(CustomerReviews);
function _temp(item_0) {
  return <Testimonial {...item_0} key={item_0.image} />;
}